import { isTooManyRequestsError } from './errors';
import { retryAfterMs } from './sharetribeSafeQuery';

/**
 * Run a Sharetribe write (initiate / transition) once.
 * A 429 must not auto-fire another write. The UI shows one Retry after
 * Retry-After / backoff.
 *
 * @param {Function} work
 * @returns {Promise<*>}
 */
export const runWriteOnce = work => {
  if (typeof work !== 'function') {
    return Promise.reject(new Error('runWriteOnce requires work()'));
  }
  return Promise.resolve()
    .then(work)
    .catch(error => {
      if (isTooManyRequestsError(error) && error) {
        error.retryAfterMs = retryAfterMs(error, 0, { jitter: 0 });
      }
      throw error;
    });
};
